import { deepCopyAggs } from './deepCopyAggs';

export function deepCopySportAggs(aggregate) {
    const result = {};
    const keys = Object.keys(aggregate);
    let pi = 0;
    let sportId = 0;

    let i = keys.length % 8;

    while (i) {
        sportId = keys[pi++];
        result[sportId] = deepCopyAggs(aggregate[sportId]);
        i--;
    }

    i = Math.floor(keys.length / 8);

    // Process 8 per loop
    while (i) {
        sportId = keys[pi++];
        result[sportId] = deepCopyAggs(aggregate[sportId]);
        sportId = keys[pi++];
        result[sportId] = deepCopyAggs(aggregate[sportId]);
        sportId = keys[pi++];
        result[sportId] = deepCopyAggs(aggregate[sportId]);
        sportId = keys[pi++];
        result[sportId] = deepCopyAggs(aggregate[sportId]);
        sportId = keys[pi++];
        result[sportId] = deepCopyAggs(aggregate[sportId]);
        sportId = keys[pi++];
        result[sportId] = deepCopyAggs(aggregate[sportId]);
        sportId = keys[pi++];
        result[sportId] = deepCopyAggs(aggregate[sportId]);
        sportId = keys[pi++];
        result[sportId] = deepCopyAggs(aggregate[sportId]);
        i--;
    }

    return result;
}
